// NOTE: app/javascripts/utils/initializeNumberAnimation.es6と同じ中身
const initializeNumberAnimation = () => {
  const numberElements = document.querySelectorAll(".jsNumberAnimation");

  if (!numberElements.length) return;

  const originalValues = new Map();

  const animateNumber = (element, start, end, duration = 2000) => {
    const startTime = performance.now();
    const difference = end - start;

    const updateNumber = (currentTime) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const easedProgress = 1 - (1 - progress) ** 3;
      const currentNumber = Math.floor(start + difference * easedProgress);

      element.textContent = currentNumber.toLocaleString();

      if (progress < 1) {
        requestAnimationFrame(updateNumber);
      } else {
        element.textContent = originalValues.get(element);
      }
    };

    requestAnimationFrame(updateNumber);
  };

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const element = entry.target;
          const originalText = originalValues.get(element);
          const targetNumber = parseInt(originalText.replace(/,/g, ""), 10);

          if (!isNaN(targetNumber)) {
            element.textContent = "0";

            setTimeout(() => {
              animateNumber(element, 0, targetNumber, 2000);
            }, 100);
          }
          observer.unobserve(element);
        }
      });
    },
    {
      threshold: 0.5, // NOTE: 要素の50%が見えた時に実行
      rootMargin: "0px",
    }
  );

  numberElements.forEach((element) => {
    // NOTE: SEO対策：元の値を保存（クローラーはこの値を読む）
    const originalText = element.textContent.trim();
    originalValues.set(element, originalText);
    observer.observe(element);
  });
};

// NOTE: esbuild はモジュールレベルの副作用がない純粋な関数宣言をバンドルから除外する
// Sprockets からの移行のため、グローバルアクセスを維持するために window に公開する

export default initializeNumberAnimation;